import { currencyLocaleMappings } from "../constants/dataConstants";
export const CurrencyFormatter = (
  currency: string,
  revenue: number,
  noDataAvailable?: string
) => {
  // Define Thai currency codes
  const thaiCurrencyCodes = ["BHT", "TBH", "THB"];
  const currencyCode = thaiCurrencyCodes.includes(currency) ? "THB" : currency;
  const locale = currencyLocaleMappings[currencyCode] || "en-US";

  if (revenue === null || revenue === undefined || isNaN(revenue)) {
    return noDataAvailable || "No data available";
  }

  return currency
    ? revenue?.toLocaleString(locale, {
        style: "currency",
        currency: currencyCode,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })
    : revenue;
};


export const CurrencyInputFormatter = (
  currencyCode: string,
  amount: number
): string => {
  const locale = currencyLocaleMappings[currencyCode] || "en-US";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 0, // usually for incomes input
  }).format(amount);
};